import React, { useState, useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Header from "@/components/Header";
import MobileCallBar from "@/components/MobileCallBar";
import LanguageModal from "@/components/LanguageModal";
import CookieConsent from "@/components/CookieConsent";
import HomePage from "@/pages/HomePage";
import Tarifs from "@/pages/Tarifs";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import LandingPage from "@/pages/LandingPage";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const hasLang = !!localStorage.getItem('i18n_language');
  const hasCookieConsent = !!localStorage.getItem('cookie_consent');

  const [showLangModal, setShowLangModal] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  // Language modal: appears after 2s on first visit
  useEffect(() => {
    if (!hasLang) {
      const t = setTimeout(() => setShowLangModal(true), 2000);
      return () => clearTimeout(t);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Cookie banner: appears 1.5s after language is already set,
  // OR 1s after user selects a language (triggered via handleLangSelect)
  useEffect(() => {
    if (hasLang && !hasCookieConsent) {
      const t = setTimeout(() => setShowCookieBanner(true), 1500);
      return () => clearTimeout(t);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLangSelect = () => {
    setShowLangModal(false);
    if (!localStorage.getItem('cookie_consent')) {
      setTimeout(() => setShowCookieBanner(true), 1000);
    }
  };

  return (
    <div className="App dark bg-[#0A0A0A] text-white min-h-screen" data-testid="app-root">
      <BrowserRouter>
        {showLangModal && <LanguageModal onSelect={handleLangSelect} />}
        <AnimatePresence>
          {showCookieBanner && (
            <CookieConsent onConsent={() => setShowCookieBanner(false)} />
          )}
        </AnimatePresence>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tarifs" element={<Tarifs />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/taxi-aeroport-ajaccio" element={<LandingPage slug="taxi-aeroport-ajaccio" />} />
          <Route path="/taxi-porticcio" element={<LandingPage slug="taxi-porticcio" />} />
          <Route path="/chauffeur-prive-corse-du-sud" element={<LandingPage slug="chauffeur-prive-corse-du-sud" />} />
          <Route path="/transfert-port-ajaccio" element={<LandingPage slug="transfert-port-ajaccio" />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
        </Routes>
        <MobileCallBar key={showLangModal ? 'lang-open' : 'lang-closed'} />
      </BrowserRouter>
    </div>
  );
}

export default App;
